import { headerControllerMapper } from '@/constants/headerControllerMapper';
export default {
    async setViewStateBaromoneyWithdrawInProgress({ commit }, payload) {
        commit('SET_VIEW_STATE_BAROMONEY_WITHDRAW_IN_PROGRESS', payload);
    },
    async startFetching({ commit }) {
        commit('START_FETCHING');
    },
    async endFetching({ commit }) {
        commit('END_FETCHING');
    },
    async setPending({ commit }, payload) {
        commit('SET_PENDING', payload);
    },
    async setTabs({ commit }, payload) {
        commit('SET_TABS', payload);
    },
    async openSearch({ commit }) {
        commit('SET_PENDING', true);
        commit('SET_SEARCH_OPENED', true);
    },
    async closeSearch({ commit }) {
        commit('SET_PENDING', false);
        commit('SET_SEARCH_OPENED', false);
        commit('SET_SEARCH_QUERY', null);
    },
    async setSearchQuery({ commit }, payload) {
        commit('SET_SEARCH_QUERY', payload);
    },
    async startAppTick({ commit }) {
        commit('SET_START_APP_TICK');
    },
    setSelectedNavItem({ commit }, item) {
        commit('SET_SELECTED_NAV_ITEM', item);
    },
    setPageTitle({ state, commit, }, customMessage) {
        let pageTitle = '';
        let result = [];
        if (customMessage) {
            pageTitle = customMessage;
        }
        else {
            // TODO 페이지 이름은 라우트 이름을 따르도록 해야 함
            const routeName = state.viewState.currentPageName;
            const mapper = headerControllerMapper[routeName];
            if (!mapper) {
                console.warn(`필요시 HeaderControllerMapper를 설정해 주세요. routeName:${routeName}`);
            }
            pageTitle = mapper ? mapper.getPageTitle() : '';
        }
        if (Array.isArray(pageTitle)) {
            result = pageTitle;
        }
        else {
            result.push(pageTitle);
        }
        commit('SET_PAGE_TITLE', result);
    },
    setCurrentPageName({ commit }, page) {
        commit('SET_CURRENT_PAGE_NAME', page);
    },
};
